import React from 'react'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import Page from 'organization/Event/TemplateEditor/Page'
import EventOfflinePage from 'Event/EventOfflinePage'
import LanguageSelector from 'organization/Event/LocalizationConfig/LanguageSelector'

export default function EventOfflinePageConfig() {
  return (
    <DesignBreadcrumbs page="Offline">
      <Page
        toolbarItems={
          <>
            <LanguageSelector />
          </>
        }
      >
        <EventOfflinePage isPreview />
      </Page>
    </DesignBreadcrumbs>
  )
}
